import { CreateActionProvider } from "../actions/create/CreateActionContext";
import { EditActionProvider } from "../actions/edit/EditActionContext";
import { ListActionProvider } from "../actions/list/ListActionContext";
import { RemoveActionProvider } from "../actions/remove/RemoveActionContext";
import SaleFormatsPage from "../pages/OptionsPage";



export default function OptionsRouterWrapper(props: { filters?: any, formDefaultValues?: any, formFilterValues?: any }) {
    const { filters, formDefaultValues, formFilterValues } = props;
    return (
      <ListActionProvider>
          <EditActionProvider>
              <RemoveActionProvider>
                  <CreateActionProvider>
                      <SaleFormatsPage filters={filters} formDefaultValues={formDefaultValues} formFilterValues={formFilterValues} />
                  </CreateActionProvider>
              </RemoveActionProvider>
          </EditActionProvider>
      </ListActionProvider>
    );
};
